module.exports = __webpack_public_path__ + "img/spouting-whale.42b49c36.png";